/* LOT-CUSTOM lot-reveal — CSS scroll reveal (<1KB). Content is visible if this never runs. */
(function(){
  var root=document.documentElement; root.classList.add('has-reveal');
  var els=[].slice.call(document.querySelectorAll('.lot-reveal'));
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(el){el.classList.add('is-in');}
  if(reduce||!('IntersectionObserver' in window)){els.forEach(show);return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    if(e.isIntersecting){show(e.target);io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
  els.forEach(function(el){io.observe(el);});
})();
